<template>
  <div class="bind-phone-wrapper pr">
    <div class="bind-phone-content flex">
      <img src="https://files.wondercv.com/translate-img/new_wondercv_logo_zh-CN.png" alt="" class="logo" @click="$router.push('/')">
      <p class="desc text_center">手机号绑定</p>
      <div class="formBox">

        <div class="formItem flex-c">
          <div class="phoneType f_14 color_40">+86</div>
          <div class="pr flex1">
            <input type="text" class="input f_16 color_40" v-model="phoneData.phone" placeholder="输入手机" maxlength="11" @focus="inputFocus('phone')">
            <div class="errorTips pa color_current f_14" v-if="errorData.phone">{{errorData.phone}}</div>
          </div>
        </div>

        <div class="formItem flex-c">
          <div class="flex1 pr">
            <input type="text" class="input f_16 color_40" v-model="phoneData.code" placeholder="请输入验证码" maxlength="6" @focus="inputFocus('code')" >
            <div class="errorTips pa color_current f_14" v-if="errorData.code">{{errorData.code}}</div>
          </div>
          <div class="getCode cursor_p text_center f_14">
            <span class="color_blue" @click="checkPhoneCode()" v-if="codeData.time === 60">发送验证码</span>
            <span class="color_9c" v-else >{{codeData.time}} 秒后可重发</span>
          </div>
        </div>
      
        <div class="submitButton cursor_p color_fff text_center bg_current f_16" @click="bindPhone()">确认绑定</div>

      </div>
    </div>
  </div>
</template>

<script>
import actions from '@/actions/index'
import * as utils from '@/utils/utils'

export default {
    data () {
    return {
      phoneData: { // 用户输入
        phone: '',
        code: ''
      },
      codeData:{
        state: false, // 是否正在获取验证码
        type: 'phone', // 当前获取类型
        time: 60 // 倒计时
      },
      errorData: { // 错误信息
        phone: '',
        code: ''
      },
      account_type:'cv_account', // 账户种类 hr_account 或 cv_account
      codeTimeoutName: null, // 验证码定时器
      jwt: ''
    }
  },
  created() {
    let _t = utils.getCookie('_t')
    this.jwt = _t
  },
  methods: {
    //取消错误提示
    inputFocus(type){
      this.errorData[type] = ''
    },
    // 获取手机号证码 前的 手机号格式校验
    checkPhoneCode () {
      console.log('aaa', this.phoneData)
      let { phone } = this.phoneData

      if (!phone) {
        this.errorData.phone = '请输入手机号'
        return false
      } else if ( !(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11 ) {
        console.log('bbbb')
        this.errorData.phone = '请输入正确的手机号'
        return false
      }

      // 是否正在获取验证码
      if(this.codeData.state){
        return false;
      }

      // 获取验证码
      this.getCode()
    },
    // 获取 手机号验证码
    getCode () {
      let { phone } = this.phoneData
      this.codeData.state = true
      let data = {
        premise: 'cv_account_unregistered',
        phone_number: phone,
        new_code: true
      }
      actions.auth.getPhoneCode(data).then(res=>{
        if(res.code === 1000){
          this.$message({
            message: '验证码已发送，请注意查收',
            type: 'success'
          });
          this.codeData.time = 59;
          this.codeTime();
        }else{
          this.codeData.state = false;
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    // 验证码倒计时
    codeTime () {
      this.codeTimeoutName = setInterval(() => {
        if(this.codeData.time === 1){
          clearInterval(this.codeTimeoutName)
          this.codeData.state = false
          this.codeData.time = 60
          return false
        }
        this.codeData.time = this.codeData.time - 1
      }, 1000)
    },
    // 绑定手机号
    bindPhone () {
      let { phone, code } = this.phoneData
      // 检查邮箱格式
      if (!phone) {
        this.errorData.phone = '请输入手机号'
        return false
      } else if ( !(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11 ) {
        this.errorData.phone = '请输入正确的手机号'
        return false
      }
      // 检查二维码格式
      if(!code || code.length !== 6){
        this.errorData.code = '请输入正确的验证码'
        return false
      }

      let data = {
        jwt: this.jwt,
        phone_number: phone,
        phone_code: code
      }

      actions.auth.user_email_bind_phone(data).then(async res => {
        if (res.code === 1000) {
          this.$message({
            message: '手机号绑定成功，页面正在跳转…',
            type: 'success',
            duration: 0
          })
          // _n_b_p: 是否没有绑定手机号
          localStorage.setItem('_n_b_p', false)
          // 跳转
          this.pageJump(false)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 登录成功 读取跳转页面
    pageJump(new_account){
      // if(new_account){
      //   //新用户跳转到cvs，然后自动会跳转到 选择身份页面
      //   window.location.href = window.location.origin+'/select_identity'
      // }else{
        let r_b_t = utils.getCookie('_r_b_t') || '';
        // 返回的url中必须有 wondercv
        if(!r_b_t.includes('wondercv')){
          r_b_t = '';
        }
        // 返回的url要进行解码再跳转
        if(r_b_t){
          r_b_t = decodeURIComponent(r_b_t);
        }
        let _t = utils.get_tUser();
        if(this.account_type==='hr_account'){
          if(!r_b_t.includes('/talent/')){
            r_b_t = '';
          }
          let hr_url = window.location.origin + `${this.isBindPhone? '/talent/userinfo':'/talent/binduser'}`
          let hr_indexUrl = window.location.origin + '/talent/search'
          //如果返回的url中包含 用户信息的url
          let link_to = r_b_t.includes(`${hr_url}`)? ( r_b_t.includes('?')?r_b_t+'&showJump=true':r_b_t+'?showJump=true' ) : `${hr_url}${r_b_t ? '?link_to='+encodeURIComponent(r_b_t)+'&showJump=true' : '?showJump=true'}`;
          // hr登录之后的判断, 是否是hr，判断是否绑定手机号 判断是否读取本地地址
          window.location.href = _t.h_t ? ( this.isBindPhone ? ( r_b_t || hr_indexUrl) : link_to ) : link_to ;
          utils.delCookie('_r_b_t');
        }else{
          // cv登录之后的判断
          if(r_b_t.includes('/talent/')){
            r_b_t = '';
          }
          // 不是新用户 && 有 r_b_t
          if(r_b_t && !new_account){
            window.location.href = r_b_t;
            utils.delCookie('_r_b_t');
          }else{
            //新用户跳转到cvs，然后自动会跳转到 选择身份页面
            window.location.href = window.location.origin+'/cvs'
          }
        }
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './Index.scss';
</style>
